module.exports = __webpack_public_path__ + "static/media/fail.3360c57c.svg";